export const access = {
  toRiser: {
    title: 'Access to riser',
    type: 'simple-text',
    value: ''
  },
  toMDF: {
    title: 'Access to MDF',
    type: 'simple-text',
    value: ''
  },
  toBuilding: {
    title: 'Access to building',
    type: 'simple-text',
    value: ''
  },
  toCarPark: {
    title: 'Access to car park',
    type: 'simple-text',
    value: ''
  },
  installationAccessTimes: {
    title: 'Installation access times',
    type: 'access-times',
    value: {
      from: '8:00',
      to: '18:00'
    }
  }
}
